import React from 'react';
import Form from 'mobx-react-form';
import { observer } from 'mobx-react-lite';
import { Checkbox, FormControl, FormControlLabel, InputAdornment, MenuItem, Select } from '@mui/material';

import { SITE_AREA_OPTIONS } from '../constants';
import NumericInput from 'components/shared/inputs/NumericInput';

type SiteAreaProps = {
  form: Form;
};

const SiteArea = observer(({ form }: SiteAreaProps) => {
  const displayInAcresAndSF = form.$('property.displayInAcresAndSF').value;

  return (
    <>
      <NumericInput
        {...form.$('property.siteArea').bind()}
        size="small"
        margin="normal"
        label="Site Area"
        fullWidth
        thousandSeparator
        decimalScale={4}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <FormControl variant="standard" sx={{ minWidth: 100 }}>
                <Select {...form.$('property.siteAreaMeasure').bind()}>
                  {SITE_AREA_OPTIONS.map(({ value, label }) => (
                    <MenuItem key={value} value={value}>
                      {label || value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </InputAdornment>
          ),
        }}
      />

      <FormControlLabel
        control={<Checkbox {...form.$('property.displayInAcresAndSF').bind()} />}
        label="Display Site Area in both SF and Acres"
      />
      {displayInAcresAndSF && (
        <NumericInput
          {...form.$('property.altSiteArea').bind()}
          label="Secondary Site Area"
          size="small"
          margin="normal"
          decimalScale={4}
          thousandSeparator
          disabled
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <FormControl variant="standard" sx={{ minWidth: 100 }}>
                  <Select {...form.$('property.altSiteAreaMeasure').bind()} disabled>
                    {SITE_AREA_OPTIONS.map(({ value, label }) => (
                      <MenuItem key={value} value={value}>
                        {label || value}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </InputAdornment>
            ),
          }}
          fullWidth
        />
      )}
    </>
  );
});

export default SiteArea;
